import { createContextValues } from '@connectrpc/connect';
import { PlatformService } from '@qdrant/qdrant-cloud-public-api/serverless/platform/v1';
import {
  getCloudRegion,
  getGlobalCloudRegion,
  listCloudRegions,
  listGlobalCloudRegions,
} from '@qdrant/qdrant-cloud-public-api/serverless/platform/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';
import { ctxKeyAuthorized } from '@/connect-query/context-keys';

const contextValues = createContextValues().set(ctxKeyAuthorized, false);

export const serverlessPlatformService = createServiceQueries(PlatformService, {
  getCloudRegionQuery: (params) => queryOptions(getCloudRegion, params, { transport }),
  getGlobalCloudRegionQuery: (params) => queryOptions(getGlobalCloudRegion, params, { transport, contextValues }),
  listCloudRegionsQuery: (params) => queryOptions(listCloudRegions, params, { transport }),
  listGlobalCloudRegionsQuery: () =>
    queryOptions(
      listGlobalCloudRegions,
      {},
      {
        transport,
        contextValues,
      },
    ),
});
